import * as React from 'react';
import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg';

import withIconWrapper from 'app/hocs/withIconWrapper';

export default withIconWrapper(function HelpCenter({ color, size, ...props }) {
  return (
    <Svg fill="none" height={size} viewBox="0 0 20 9" width={size} {...props}>
      <G clipPath="url(#clip0_1_563)">
        <Path
          clipRule="evenodd"
          d="M4.93332 8.22863H9.46665L11.5333 0.771484H4.93332C2.79998 0.771484 1.06665 2.44291 1.06665 4.50006C1.06665 6.5572 2.79998 8.22863 4.93332 8.22863Z"
          fill="white"
          fillRule="evenodd"
        />
        <Path
          clipRule="evenodd"
          d="M15.0667 0H4.93339C2.33339 0 0.266724 1.99286 0.266724 4.5C0.266724 7.00714 2.33339 9 4.93339 9H15.0667C17.6667 9 19.7334 7.00714 19.7334 4.5C19.7334 1.99286 17.6001 0 15.0667 0ZM1.06672 4.5C1.06672 2.44286 2.80006 0.771429 4.93339 0.771429H11.5334L9.46672 8.22857H4.93339C2.80006 8.22857 1.06672 6.55714 1.06672 4.5Z"
          fill={color}
          fillRule="evenodd"
        />
        <Path
          d="M16.4 2.5714C16.5334 2.69998 16.5334 2.95712 16.4 3.08569L15 4.49998L16.4667 5.91426C16.6 6.04283 16.6 6.29998 16.4667 6.42855C16.3334 6.55712 16.0667 6.55712 15.9334 6.42855L14.4667 5.01426L13 6.42855C12.8667 6.55712 12.6 6.55712 12.4667 6.42855C12.3334 6.29998 12.3334 6.04283 12.4667 5.91426L13.8667 4.49998L12.4 3.08569C12.2667 2.95712 12.2667 2.69998 12.4 2.5714C12.5334 2.44283 12.8 2.44283 12.9334 2.5714L14.4 3.98569L15.8667 2.5714C16 2.44283 16.2667 2.44283 16.4 2.5714Z"
          fill="white"
        />
        <Path
          d="M8.46667 2.63574C8.6 2.76431 8.66667 3.02145 8.53333 3.15002L5.73333 6.30002C5.66667 6.36431 5.6 6.42859 5.53333 6.42859C5.4 6.49288 5.2 6.49288 5.06667 6.36431L3.6 4.95002C3.46667 4.82145 3.46667 4.56431 3.6 4.43574C3.73333 4.30716 4 4.30716 4.13333 4.43574L5.33333 5.52859L7.86667 2.63574C8 2.50716 8.26667 2.50716 8.46667 2.63574Z"
          fill={color}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_1_563">
          <Rect fill="white" height="9" width="20" />
        </ClipPath>
      </Defs>
    </Svg>
  );
});
